import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function ProtectedRoute({ admin = false }: { admin?: boolean }) {
  const { user, role, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div className="route-loader" role="status">Consultando credencial…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (admin && role !== 'admin') return <Navigate to="/perfil" replace />;
  return <Outlet />;
}
